import { ITextStyles } from '@fluentui/react';
import { FontSizes, mediaNoDesktop } from '@h2oai/ui-kit';

import { stackStylesAppStorePage } from '../../themes/themes';

export const appStorePageStyles = (): Partial<ITextStyles> => ({
  root: {
    ...(stackStylesAppStorePage.root as object),

    // Search
    '.search-box-container': {
      ...mediaNoDesktop({
        marginBottom: 62,
        '.ms-SearchBox': { height: 48 },
        input: { fontSize: FontSizes.small },
        i: { fontSize: FontSizes.xlarge },
      }),
    },

    // Grid
    '.card-grid': {
      ...mediaNoDesktop({ margin: '0 -18px' }),
      '.h2o-CardList-root': {
        ...mediaNoDesktop({
          display: 'flex',
          overflow: 'auto',
          margin: 0,
        }),
      },
      'section.AppStoreSection, section.app-section--detailed-listing': {
        ...mediaNoDesktop({ marginBottom: 10 }),
        '> header': {
          ...mediaNoDesktop({
            marginBottom: 11,
            padding: '0 18px',
          }),
        },
      },
      h1: {
        ...mediaNoDesktop({
          padding: '0 !important',
          fontSize: '18px !important',
          lineHeight: '22px !important',
        }),
      },
      '.h2o-ButtonContainer-root .ms-Button': { ...mediaNoDesktop({ minHeight: 0 }) },
      '.h2o-CardList-item': {
        ...mediaNoDesktop({
          width: '37.5vw',
          minWidth: 160,
          maxWidth: 240,
          flexGrow: 0,
          flexShrink: 0,
          margin: 0,
        }),
      },
      '.h2o-CardList-item:first-child': { ...mediaNoDesktop({ marginLeft: 18 }) },
      '.h2o-CardList-item:not(:last-child)': { ...mediaNoDesktop({ marginRight: '1.6vw' }) },
      '.h2o-CardList-item .h2o-Card-content .h2o-Card-header': { ...mediaNoDesktop({ marginBottom: 0 }) },
      '.h2o-CardList-item .h2o-Card-thumbnailImage': { ...mediaNoDesktop({ marginBottom: 8 }) },
      '.h2o-CardList-item .h2o-Card-thumbnailImage:after': { ...mediaNoDesktop({ paddingBottom: '95%' }) },
      '.h2o-Card-headerTitle': {
        ...mediaNoDesktop({
          fontSize: FontSizes.xsmall,
          lineHeight: FontSizes.medium,
        }),
      },
      '.h2o-Card-thumbnailBadgeList': { ...mediaNoDesktop({ paddingTop: 8 }) },
    },
  },
});
